import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { RolesProvider } from './contexts/RolesContext'
import './index.css'
import { AppRoutes } from './routes'

/**
 * Resolution guard – only renders the app when the screen is
 * 1080 × 1920 in portrait orientation (vertical totem).
 * Shows an informative overlay otherwise.
 */
function ResolutionGuard({ children }: { children: React.ReactNode }) {
  const [ok, setOk] = useState(true);

  useEffect(() => {
    const check = () => {
      const w = window.screen.width;
      const h = window.screen.height;
      const portrait = w < h; // portrait = vertical

      // Accept exact 1080×1920, or any window on a 1080×1920 screen
      const isCorrectScreen =
        (w === 1080 && h === 1920) ||
        (h === 1080 && w === 1920 && !portrait);

      // Also allow if innerWidth/innerHeight match (full-screen kiosk)
      const innerOk =
        (window.innerWidth === 1080 && window.innerHeight === 1920) ||
        (window.innerWidth <= 1080 && window.innerHeight <= 1920 && portrait);

      setOk(isCorrectScreen || innerOk);
    };

    check();
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, []);

  if (!ok) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)',
          color: '#fff',
          fontFamily: 'Arial, Helvetica, sans-serif',
          textAlign: 'center',
          padding: 40,
          zIndex: 99999,
        }}
      >
        <div style={{ fontSize: 64, marginBottom: 24 }}>🖥️</div>
        <h1 style={{ fontSize: 28, marginBottom: 16, color: '#e94560' }}>
          Resolução Incorreta
        </h1>
        <p style={{ fontSize: 18, lineHeight: 1.6, maxWidth: 520, marginBottom: 20 }}>
          Este aplicativo foi projetado para funcionar em um <strong>totem vertical</strong> com
          resolução <strong>1080 × 1920 pixels</strong> (modo retrato).
        </p>
        <p style={{ fontSize: 16, opacity: 0.7, lineHeight: 1.5, maxWidth: 520 }}>
          Sua tela atual: <strong>{window.screen.width} × {window.screen.height}</strong>
          <br />
          Janela: <strong>{window.innerWidth} × {window.innerHeight}</strong>
        </p>
        <p style={{ fontSize: 14, opacity: 0.5, marginTop: 24 }}>
          Ajuste a resolução e orientação do monitor para continuar.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}

ReactDOM.render(
  <RolesProvider>
    <React.StrictMode>
      <ResolutionGuard>
        <AppRoutes />
      </ResolutionGuard>
    </React.StrictMode>
  </RolesProvider>,
  document.getElementById('root')
);